/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface BeamAnalysisCorrectionValuesDto
 */
export interface BeamAnalysisCorrectionValuesDto {
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisCorrectionValuesDto
     */
    airTemperature?: number;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisCorrectionValuesDto
     */
    airPressure?: number;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisCorrectionValuesDto
     */
    referenceTemperature?: number;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisCorrectionValuesDto
     */
    referencePressure?: number;
    /**
     * 
     * @type {number}
     * @memberof BeamAnalysisCorrectionValuesDto
     */
    correctionFactor?: number;
    /**
     * 
     * @type {string}
     * @memberof BeamAnalysisCorrectionValuesDto
     */
    $type?: BeamAnalysisCorrectionValuesDtoTypeEnum;
}


/**
 * @export
 */
export const BeamAnalysisCorrectionValuesDtoTypeEnum = {
    PtwPtw100BeamAnalysisApplicationJobExecutionDtoBeamAnalysisCorrectionValuesDtoPtwPtw100BeamAnalysisApplication: 'Ptw.Ptw100.BeamAnalysis.Application.JobExecution.Dto.BeamAnalysisCorrectionValuesDto, Ptw.Ptw100.BeamAnalysis.Application'
} as const;
export type BeamAnalysisCorrectionValuesDtoTypeEnum = typeof BeamAnalysisCorrectionValuesDtoTypeEnum[keyof typeof BeamAnalysisCorrectionValuesDtoTypeEnum];



/**
 * Check if a given object implements the BeamAnalysisCorrectionValuesDto interface.
 */
export function instanceOfBeamAnalysisCorrectionValuesDto(value?: unknown): value is BeamAnalysisCorrectionValuesDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(BeamAnalysisCorrectionValuesDtoTypeEnum)[0];
}

export function BeamAnalysisCorrectionValuesDtoFromJSON(json: any): BeamAnalysisCorrectionValuesDto {
    return BeamAnalysisCorrectionValuesDtoFromJSONTyped(json, false);
}

export function BeamAnalysisCorrectionValuesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeamAnalysisCorrectionValuesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'airTemperature': json['airTemperature'] == null ? undefined : json['airTemperature'],
        'airPressure': json['airPressure'] == null ? undefined : json['airPressure'],
        'referenceTemperature': json['referenceTemperature'] == null ? undefined : json['referenceTemperature'],
        'referencePressure': json['referencePressure'] == null ? undefined : json['referencePressure'],
        'correctionFactor': json['correctionFactor'] == null ? undefined : json['correctionFactor'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function BeamAnalysisCorrectionValuesDtoToJSON(value?: BeamAnalysisCorrectionValuesDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'airTemperature': value['airTemperature'],
        'airPressure': value['airPressure'],
        'referenceTemperature': value['referenceTemperature'],
        'referencePressure': value['referencePressure'],
        'correctionFactor': value['correctionFactor'],
        '$type': value['$type'],
    });
}

